// ----------------------------------------------------------------------
// <copyright file="Izenda.GridDefaultConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import GRID_DEFAULT_FUNCTION from 'logic/data/Izenda.GridDefaultFunction';

const DEFAULT_SORT_VIRTICAL_HORIZONTAL = {
  columns: 'Unsorted',
  separators: 'ASC',
  rows: 'Unsorted'
};

const DEFAULT_SORT_DRILL_DOWN = {
  rows: 'ASC',
  separators: 'ASC'
};

const DEFAULT_SORT_PIVOT = {
  rows: 'Unsorted',
  columns: 'ASC',
  separators: 'ASC'
};

const HORIZONTAL_DEFAULT_CONFIG = {
  DEFAULT_FUNCTION: GRID_DEFAULT_FUNCTION.HORIZONTAL_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_SEPARATORS: GRID_DEFAULT_FUNCTION.HORIZONTAL_DEFAULT_FUNCTION_WITH_SEPARATORS,
  DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION: GRID_DEFAULT_FUNCTION.HORIZONTAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION,
  DEFAULT_SORT: DEFAULT_SORT_VIRTICAL_HORIZONTAL
};
const VERTICAL_DEFAULT_CONFIG = {
  DEFAULT_FUNCTION: GRID_DEFAULT_FUNCTION.VERTICAL_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_SEPARATORS: GRID_DEFAULT_FUNCTION.VERTICAL_DEFAULT_FUNCTION_WITH_SEPARATORS,
  DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION: GRID_DEFAULT_FUNCTION.VERTICAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION,
  DEFAULT_SORT: DEFAULT_SORT_VIRTICAL_HORIZONTAL
};
const DRILL_DOWN_DEFAULT_CONFIG = {
  DEFAULT_FUNCTION: GRID_DEFAULT_FUNCTION.DRILL_DOWN_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_SEPARATORS: GRID_DEFAULT_FUNCTION.DRILL_DOWN_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION: GRID_DEFAULT_FUNCTION.DRILL_DOWN_DEFAULT_FUNCTION,
  DEFAULT_SORT: DEFAULT_SORT_DRILL_DOWN
};
const PIVOT_DEFAULT_CONFIG = {
  DEFAULT_FUNCTION: GRID_DEFAULT_FUNCTION.PIVOT_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_SEPARATORS: GRID_DEFAULT_FUNCTION.PIVOT_DEFAULT_FUNCTION,
  DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION: GRID_DEFAULT_FUNCTION.PIVOT_DEFAULT_FUNCTION,
  DEFAULT_SORT: DEFAULT_SORT_PIVOT
};

export default {
  DefaultConfig: {
    Pivot: PIVOT_DEFAULT_CONFIG,
    Horizontal: HORIZONTAL_DEFAULT_CONFIG,
    Vertical: VERTICAL_DEFAULT_CONFIG,
    Drilldown: DRILL_DOWN_DEFAULT_CONFIG
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.GridDefaultConfig.js